import { Phone, MapPin, Instagram, MessageCircle, Lock, Facebook } from "lucide-react";
import { Link } from "react-router-dom";
import { CLINIC } from "@/lib/clinic";
import { buildWhatsAppLink } from "@/components/site/WhatsApp";

export default function Footer({ waNumber }) {
  return (
    <footer data-testid="site-footer" className="bg-[#1C221F] text-white/85">
      <div className="container-x py-14 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-[#D4B27E] text-[#1C221F] font-display font-bold text-sm">
              CS
            </span>
            <span className="font-display font-semibold text-white text-lg">City Smiles Dental Clinic</span>
          </div>
          <p className="mt-4 text-sm text-white/60 max-w-md">
            Compassionate, modern dental care for families across Ratia and Fatehabad district.
            Because a healthy smile changes everything.
          </p>
          <div className="flex items-center gap-3 mt-6">
            <a
              href={CLINIC.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              data-testid="footer-instagram"
              className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#D4B27E] hover:text-[#1C221F] flex items-center justify-center transition-colors"
            >
              <Instagram className="w-4 h-4" strokeWidth={1.75} />
            </a>
            <a
              href={CLINIC.facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              data-testid="footer-facebook"
              className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#D4B27E] hover:text-[#1C221F] flex items-center justify-center transition-colors"
            >
              <Facebook className="w-4 h-4" strokeWidth={1.75} />
            </a>
            <a
              href={buildWhatsAppLink(waNumber || CLINIC.phoneDial)}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              data-testid="footer-whatsapp"
              className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#25D366] hover:text-white flex items-center justify-center transition-colors"
            >
              <MessageCircle className="w-4 h-4" strokeWidth={1.75} />
            </a>
            <a
              href={`tel:${CLINIC.phoneDial}`}
              aria-label="Call"
              className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#D4B27E] hover:text-[#1C221F] flex items-center justify-center transition-colors"
            >
              <Phone className="w-4 h-4" strokeWidth={1.75} />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="text-sm uppercase tracking-[0.2em] text-[#D4B27E] font-medium">Explore</div>
          <ul className="mt-4 space-y-2 text-sm">
            {[
              ["Services", "#services"],
              ["About", "#about"],
              ["Doctor", "#doctor"],
              ["Reviews", "#reviews"],
              ["Book Appointment", "#contact"],
            ].map(([label, href]) => (
              <li key={label}>
                <a href={href} className="hover:text-white transition-colors" data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}>
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-sm uppercase tracking-[0.2em] text-[#D4B27E] font-medium">Contact</div>
          <ul className="mt-4 space-y-3 text-sm text-white/70">
            <li className="flex gap-3">
              <MapPin className="w-4 h-4 mt-0.5 text-[#D4B27E] shrink-0" strokeWidth={1.75} />
              <span>{CLINIC.address}</span>
            </li>
            <li className="flex gap-3">
              <Phone className="w-4 h-4 mt-0.5 text-[#D4B27E] shrink-0" strokeWidth={1.75} />
              <a href={`tel:${CLINIC.phoneDial}`} className="hover:text-white">{CLINIC.phoneDisplay}</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x py-5 text-xs text-white/50 flex flex-col sm:flex-row items-center justify-between gap-2">
          <span>© {new Date().getFullYear()} City Smiles Dental Clinic. All rights reserved.</span>
          <span className="flex items-center gap-4">
            <span>Made with care in Ratia, Haryana.</span>
            <Link
              to="/admin"
              data-testid="footer-admin-link"
              className="inline-flex items-center gap-1.5 text-white/40 hover:text-[#D4B27E] transition-colors"
            >
              <Lock className="w-3 h-3" strokeWidth={1.75} />
              Staff login
            </Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
